import React, { Component } from 'react';
import ReactPlayer from 'react-player'
import './overlay.css';

/** @class Overlay
 * Displays a piece of content in a modal overlay.
 */
export default class Overlay extends Component {
  constructor(props){
    super(props);
    this.state = {visible: false}
    this.exit = this.exit.bind(this);
    this.showContent = this.showContent.bind(this);
    this.prepContent = this.prepContent.bind(this);
  }
  exit(){
    this.setState({
      content: undefined,
      visible: false
    });
  }
  prepContent(content) {
    switch(content.type) {
      case 'article':
        return (<div dangerouslySetInnerHTML={{__html: content.html}}></div>);
      case 'image':
        var html = {__html: content.caption};
        return (
          <div className="centered">
            <img src={content.image} alt={content.alt}/>
            <div className="caption" dangerouslySetInnerHTML={html} />
          </div>
        );
      case 'audio':
        return (<audio src={content.audio} autoplay={true} controls={true} />)
      case 'video':
        return (<ReactPlayer url={content.video} playing controls={true} />)
      default:
        return '';
    }
  }
  showContent(content) {
    this.setState({
      visible: true,
      content: this.prepContent(content)
    });
  }
  componentDidMount() {
    if(!window.vexpo) window.vexpo = {};
    window.vexpo.overlay = this.showContent;
  }
  render() {
    var visibleClass = (this.state.visible) ? 'active' : '';
    return (
      <div className={`overlay ${visibleClass}`}>

        <div className="close-overlay">
          <a onClick={()=>this.exit()}>
            <i className="fa fa-times"></i>
            <small>CLOSE</small>
          </a>
        </div>

        <div className="overlay-content">
          {this.state.content}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/overlay/overlay.js